import { IFilter } from "@saleor/components/Filter";
import { FilterOpts, MinMax } from "@saleor/types";
import {
  DiscountStatusEnum,
  DiscountValueTypeEnum
} from "@saleor/types/globalTypes";
import {
  createDateField,
  createOptionsField
} from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum SaleFilterKeys {
  saleType = "saleType",
  started = "started",
  status = "status"
}

export interface SaleListFilterOpts {
  saleType: FilterOpts<DiscountValueTypeEnum>;
  started: FilterOpts<MinMax>;
  status: FilterOpts<DiscountStatusEnum[]>;
}

const messages = defineMessages({
  absolute: {
    defaultMessage: "Absolute Value",
    description: "discount type"
  },
  active: {
    defaultMessage: "Active",
    description: "sale status"
  },
  deactivated: {
    defaultMessage: "Deactivated",
    description: "voucher status"
  },
  expired: {
    defaultMessage: "Expired",
    description: "sale status"
  },
  fixed: {
    defaultMessage: "Fixed amount",
    description: "discount type"
  },
  percentage: {
    defaultMessage: "Percentage",
    description: "discount type"
  },
  scheduled: {
    defaultMessage: "Scheduled",
    description: "sale status"
  },
  started: {
    defaultMessage: "Start Date",
    description: "sale start date"
  },
  status: {
    defaultMessage: "Discount Status",
    description: "sale status"
  },
  type: {
    defaultMessage: "Discount Type"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: SaleListFilterOpts
): IFilter<SaleFilterKeys> {
  return [
    {
      ...createDateField(
        SaleFilterKeys.started,
        intl.formatMessage(messages.started),
        opts.started.value
      ),
      active: opts.started.active
    },
    {
      ...createOptionsField(
        SaleFilterKeys.status,
        intl.formatMessage(messages.status),
        opts.status.value,
        true,
        [
          {
            label: intl.formatMessage(messages.active),
            value: DiscountStatusEnum.ACTIVE
          },
          {
            label: intl.formatMessage(messages.expired),
            value: DiscountStatusEnum.EXPIRED
          },
          {
            label: intl.formatMessage(messages.scheduled),
            value: DiscountStatusEnum.SCHEDULED
          },
          {
            label: intl.formatMessage(messages.deactivated),
            value: DiscountStatusEnum.INACTIVE
          }
        ]
      ),
      active: opts.status.active
    },
    {
      ...createOptionsField(
        SaleFilterKeys.saleType,
        intl.formatMessage(messages.type),
        [opts.saleType.value],
        false,
        [
          // {
          //   label: intl.formatMessage(messages.fixed),
          //   value: DiscountValueTypeEnum.FIXED
          // },
          {
            label: intl.formatMessage(messages.percentage),
            value: DiscountValueTypeEnum.PERCENTAGE
          },
          {
            label: intl.formatMessage(messages.absolute),
            value: DiscountValueTypeEnum.ABSOLUTE_VALUE
          }
        ]
      ),
      active: opts.saleType.active
    }
  ];
}
